import { render, staticRenderFns } from "./StarterKitModal.vue?vue&type=template&id=24c67fc5&scoped=true"
import script from "./StarterKitModal.vue?vue&type=script&lang=js"
export * from "./StarterKitModal.vue?vue&type=script&lang=js"
import style0 from "./StarterKitModal.vue?vue&type=style&index=0&id=24c67fc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c67fc5",
  null
  
)

export default component.exports